// extracted by mini-css-extract-plugin
export var cardTitle = "_ib-1";
export var commentBubble = "_ib-e";
export var commentForm = "_ib-a";
export var commentInput = "_ib-b";
export var commentLabel = "_ib-d";
export var commentPrompt = "_ib-9";
export var csatCard = "_ib-0";
export var feedbackSection = "_ib-7";
export var starDisabled = "_ib-6";
export var starEmpty = "_ib-5";
export var starFilled = "_ib-4";
export var starWrapper = "_ib-3";
export var starsContainer = "_ib-2";
export var submittedComment = "_ib-c";
export var thankYouText = "_ib-8";